module.exports = __webpack_public_path__ + "img/juLeiCa.0df1c0d.png";